import 'polyfills'
import 'stylesheets/fonts/inter.scss'
import { setDefaultOptions } from 'date-fns'
import React from 'react'
import { createRoot } from 'react-dom/client'

import * as Sentry from '@sentry/react'
import AppLogin from 'pages/Login/AppLogin'

setDefaultOptions({ firstWeekContainsDate: 4, weekStartsOn: 1 })

const render = () => {
  const rootElement = document.querySelector('#root')

  if (!rootElement) return
  const root = createRoot(rootElement, {
    // Callback called when React catches an error in an ErrorBoundary.
    onCaughtError: Sentry.reactErrorHandler(),
    // Callback called when React automatically recovers from errors.
    onRecoverableError: Sentry.reactErrorHandler(),
    // Callback called when an error is thrown and not caught by an ErrorBoundary.
    onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
      console.warn('Uncaught error', error, errorInfo.componentStack)
    }),
  })

  root.render(<AppLogin />)
}

;['complete', 'interactive'].includes(document.readyState)
  ? render()
  : window.addEventListener('DOMContentLoaded', render)
